import React, { useEffect, useRef, useState } from 'react';

// v1.3: Ambient "brainrot chat" ticker — fake Twitch-style chat messages that scroll on their own,
// intended to make the game feel alive when no real Twitch stream is connected.

const USERS = [
  'gigachadxx', 'skibidi_ohio', 'ratio_lord', 'copium_addict', 'sigma_69',
  'ai_slop_bot', 'gooncoin_wallet', 'mog_master', 'lorem_ipsum_gooner', 'basedwoman',
  'anonymouse', 'urmom_1337', 'schizoposter', 'delulu_delilah', 'brainrotBoy',
  'the_yapper', 'npc_speaker', 'no_thoughts', 'huzz_pilled', 'wallet_devnull',
];
const LINES = [
  'W run', 'L run', 'RATIO', 'COPE', 'SEETHE', 'MOG', 'SLOP', 'GOATED',
  'this guy CAN NOT play',  'brainrot detected', 'i love slop', 'more slop plz',
  '📉📉📉', '🔥🔥🔥', '👁👁', 'ohio moment', 'skill issue', 'skibidi rizz',
  'im gooning', 'unc pls', 'chat is this real', 'GYATT', 'BOWSER',
  'ai slop appreciate', 'never touch grass', 'certified slop moment',
  'no way ratio+cope combo', 'give me the seed', 'lmaoooo', 'HOLY SLOP',
  'buff sigma class', 'nerf boss', 'first try btw', 'ez clap', 'stream sniper detected',
  'ratio + L + touch grass', 'chat we cooking', 'chat we are so back',
  'this stream is peak', 'brb goon session', 'let him cook', 'him ⁉',
  'that card is FIRE', 'delete that card holy', 'save it for the boss',
];
const COLORS = ['#39ff14', '#ff007f', '#00e5ff', '#ffe74a', '#a0ff2e', '#ff2ea6', '#7cd3fc', '#c084fc', '#fff'];

function pickMsg(id) {
  return {
    id,
    user: USERS[Math.floor(Math.random() * USERS.length)],
    text: LINES[Math.floor(Math.random() * LINES.length)],
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
  };
}

export default function BrainrotTicker({ compact = false, testid = 'brainrot-ticker' }) {
  const [msgs, setMsgs] = useState(() => Array.from({ length: 3 }, (_, i) => pickMsg(i)));
  const nextIdRef = useRef(3);

  useEffect(() => {
    const iv = setInterval(() => {
      const id = nextIdRef.current++;
      setMsgs(m => [...m.slice(-(compact ? 2 : 5)), pickMsg(id)]);
    }, 2100);
    return () => clearInterval(iv);
  }, [compact]);

  return (
    <div className={`brainrot-ticker ${compact ? 'brainrot-ticker-compact' : ''}`} data-testid={testid}>
      {msgs.map(m => (
        <div key={m.id} className="brainrot-line" data-testid="brainrot-line">
          <span className="brainrot-user" style={{ color: m.color }}>{m.user}</span>
          <span className="brainrot-text">{m.text}</span>
        </div>
      ))}
    </div>
  );
}
